export const routes = {
  LOGIN: "/login",

  COURSES_CATEGORIES: "/courses/categories/",
  COURSES_CATEGORIES_ADD: "/courses/categories/add",
  COURSES_CATEGORIES_EDIT: (categoryId: string = ":categoryId") => `/courses/categories/edit/${categoryId}`,
  COURSES_CATEGORIES_EDIT_TERMS: (categoryId: string = ":categoryId") => `/courses/categories/edit/${categoryId}/terms`,
  COURSES_CATEGORIES_EDIT_FORM_GROUPS: (categoryId: string = ":categoryId") =>
    `/courses/categories/edit/${categoryId}/form-groups`,

  STUDENT: (studentId: string | number = ":studentId") => `/students/${studentId}`,
  STUDENT_COURSE: (studentId: string | number = ":studentId") => `/students/${studentId}/`,
  STUDENT_ACTIONS: "application-form",
  STUDENT_COURSE_COURSES: "courses",
  STUDENT_PAYMENTS: "payments",
  STUDENT_EXAMS: "exams",
  STUDENT_DOCUMENTS: "documents",
  STUDENT_NESTED: {
    COURSES: (studentId: string | number = ":studentId", courseId: string | number = ":courseId") =>
      `${routes.STUDENT_COURSE(studentId)}${routes.STUDENT_COURSE_COURSES}/${courseId}/`,
    PAYMENTS: (studentId: string | number = ":studentId", courseId: number) =>
      `${routes.STUDENT_NESTED.COURSES(studentId, courseId)}${routes.STUDENT_PAYMENTS}`,
    EXAMS: (studentId: string | number = ":studentId", courseId: number) =>
      `${routes.STUDENT_NESTED.COURSES(studentId, courseId)}${routes.STUDENT_EXAMS}`,
    ACTIONS: (studentId: string | number = ":studentId", courseId: number) =>
      `${routes.STUDENT_NESTED.COURSES(studentId, courseId)}${routes.STUDENT_ACTIONS}`,
    DOCUMENTS: (studentId: string | number = ":studentId", courseId: number) =>
      `${routes.STUDENT_NESTED.COURSES(studentId, courseId)}${routes.STUDENT_DOCUMENTS}`,
  },

  STUDENT_COURSES: (studentId: string | number = ":studentId") => `/students/${studentId}/courses`,
  STUDENT_EDIT: (studentId: string | number = ":studentId") => `/students/edit/${studentId}`,
  STUDENTS_BLOCKED: "/students/blocked",
  STUDENTS: "/students/list",
  STUDENTS_INVITED: "/students/invited",
  USERS_ADD: "/users/add",

  COURSE_GROUPS: "/course-groups/",
  COURSE_GROUPS_ADD: "/course-groups/add",
  COURSE_GROUPS_EDIT: (courseGroupId: string = ":courseGroupId") => `/course-groups/edit/${courseGroupId}`,
  COURSE_GROUPS_EDIT_PREVIEW: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/preview`,
  COURSE_GROUPS_EDIT_CONTACT: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/contact`,
  COURSE_GROUPS_EDIT_DETAILED_INFO: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/detailed-info`,
  COURSE_GROUPS_EDIT_AGENDA: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/agenda`,
  COURSE_GROUPS_EDIT_COURSES: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/courses`,
  COURSE_GROUPS_EDIT_FAQ: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/faq`,
  COURSE_GROUPS_EDIT_ATTRIBUTES: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/attributes`,
  COURSE_GROUPS_EDIT_WAITLIST: (courseGroupId: string = ":courseGroupId") =>
    `/course-groups/edit/${courseGroupId}/waitlist`,
  COURSE_GROUPS_IMAGES: "/course-groups/images",
  COURSE_GROUPS_ATTRIBUTES: "/course-groups/attributes",
  COURSE_GROUPS_ATTRIBUTES_ADD: "/course-groups/attributes/add",
  COURSE_GROUPS_ATTRIBUTES_EDIT: (attributeId: string = ":attributeId") =>
    `/course-groups/attributes/edit/${attributeId}`,
  COURSES: "/courses/list",

  NOTIFICATIONS: "/notifications",
  COURSES_MANAGE: (courseId: string | number = ":courseId") => `/courses/${courseId}`,
  COURSES_MANAGE_DOCUMENTS: "documents",
  COURSES_MANAGE_EXAMS: (courseExamId: string = ":courseExamId") => `courseExams/${courseExamId}`,
  COURSES_MANAGE_EXAM: (
    courseExamId: string = ":courseExamId",
    userId: string = ":userId",
    userExamId: string | number = ":userExamId",
  ) => `courseExams/${courseExamId}/users/${userId}/userExams/${userExamId}`,
  COURSES_MANAGE_DOCUMENT: (templateId: string = ":templateId") => `documents/${templateId}`,
  COURSES_MANAGE_RESOURCES: `resources`,
  COURSES_MANAGE_STUDENTS: `students`,
  COURSES_MANAGE_ATTENDANCE: `attendance`,
  COURSES_MANAGE_INTEGRATIONS: `integrations`,
  COURSES_MANAGE_STUDENTS_INVITE: `students/invite`,
  COURSES_MANAGE_FINANCES: `finances`,
  COURSES_MANAGE_RECONCILIATION: `finances/reconciliation`,
  COURSES_MANAGE_FORM: (formId: string | number) => `forms/${formId}`,
  COURSES_MANAGE_NESTED: {
    EXAMS: (courseId: string | number = ":courseId", courseExamId: string | number = ":courseExamId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_EXAMS(courseExamId + "")}`,
    USER_EXAM: (
      courseId: string | number = ":courseId",
      courseExamId: string | number = ":courseExamId",
      userId: string | number = ":userId",
      userExamId: string | number = ":userExamId",
    ) => `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_EXAM(courseExamId + "", userId + "", userExamId)}`,
    DOCUMENTS: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_DOCUMENTS}`,
    DOCUMENT: (courseId: string | number = ":courseId", templateId: string = ":templateId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_DOCUMENT(templateId)}`,
    RESOURCES: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_RESOURCES}`,
    STUDENTS: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_STUDENTS}`,
    ATTENDANCE: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_ATTENDANCE}`,
    INTEGRATIONS: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_INTEGRATIONS}`,
    STUDENTS_INVITE: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_STUDENTS_INVITE}`,
    FINANCES: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_FINANCES}`,
    RECONCILIATION: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_RECONCILIATION}`,
    FORM: (courseId: string | number = ":courseId", formId: string | number = ":formId") =>
      `${routes.COURSES_MANAGE(courseId)}/${routes.COURSES_MANAGE_FORM(formId)}`,
  },
  COURSE_PAGE: {
    BASE: (courseId: string | number = ":courseId") => `/course/${courseId}`,
    SUBPAGE: {
      DOCUMENTS: "documents",
      DOCUMENTS_EDIT: "documents/edit",
      LECTURE_CONFIRMATIONS: "lecture-confirmations",
    },
    DOCUMENTS: (courseId: string | number = ":courseId") => `/course/${courseId}/documents`,
    DOCUMENTS_EDIT: (courseId: string | number = ":courseId") => `/course/${courseId}/documents/edit`,
    LECTURE_CONFIRMATIONS: (courseId: string | number = ":courseId") => `/course/${courseId}/lecture-confirmations`,
  },
  COURSES_EDIT: (courseId: string | number = ":courseId*") => `/courses/edit/${courseId}`,
  COURSES_EDIT_INFO: "info",
  COURSES_EDIT_PAYMENTS: "payments",
  COURSES_EDIT_PAYMENTS_POLICY: "payment-policy",
  COURSES_EDIT_FORM: "form",
  COURSES_EDIT_SURVEYS: "surveys",
  COURSES_EDIT_EXAMS: "exams",
  COURSES_EDIT_SCHEDULE: "schedule",
  COURSES_EDIT_SESSION: "session",
  COURSES_EDIT_PREVIEW: "preview",
  COURSES_EDIT_NESTED: {
    INFO: (courseId: string | number = ":courseId") => `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_INFO}`,
    EXAMS: (courseId: string | number = ":courseId") => `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_EXAMS}`,
    SCHEDULE: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_SCHEDULE}`,
    PREVIEW: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_PREVIEW}`,
    SESSION: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_SESSION}`,
    PAYMENTS: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_PAYMENTS}`,
    PAYMENTS_POLICY: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_PAYMENTS_POLICY}`,
    FORM: (courseId: string | number = ":courseId") => `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_FORM}`,
    SURVEYS: (courseId: string | number = ":courseId") =>
      `${routes.COURSES_EDIT(courseId)}/${routes.COURSES_EDIT_SURVEYS}`,
  },
  COURSES_ADD: "/courses/add/",

  DOCUMENTS: "/documents/",
  DOCUMENTS_PAGES: (documentTemplateId: string = ":documentTemplateId") => `/documents/${documentTemplateId}/pages`,
  DOCUMENTS_ADD: "/documents/add/",
  DOCUMENTS_EDIT: (documentTemplateId: string = ":documentTemplateId") => `/documents/edit/${documentTemplateId}`,

  KSEF: "/ksef/",
  KSEF_ADD: "/ksef/add/",
  KSEF_EDIT: (ksefId: string = ":ksefId") => `/ksef/edit/${ksefId}/`,
  KSEF_VIEW: (ksefId: string = ":ksefId") => `/ksef/view/${ksefId}/`,

  INTEGRATIONS: "/integrations/",
  INTEGRATIONS_ADD: "/integrations/add/",
  INTEGRATIONS_EDIT: (integrationId: string = ":integrationId") => `/integrations/edit/${integrationId}`,
  INTEGRATIONS_VIEW: (integrationId: string = ":integrationId") => `/integrations/view/${integrationId}`,
  INTEGRATIONS_COURSE_GROUPS: (integrationId: string = ":integrationId", courseGroupId: string = ":courseGroupId") =>
    `/integrations/view/${integrationId}/course-groups/${courseGroupId}`,

  EXAMS: "/exams/",
  EXAMS_ADD: "/exams/add/",
  EXAMS_CREATOR: (examId: string | number = ":examId") => `/exams/${examId}/questions`,
  EXAMS_EDIT: (examId: string | number = ":examId") => `/exams/edit/${examId}`,

  SURVEYS: "/surveys/",
  SURVEYS_ADD: "/surveys/add/",
  SURVEYS_EDIT: (surveyId: string = ":surveyId") => `/surveys/edit/${surveyId}`,
  SURVEYS_PAGES: (surveyId: string = ":surveyId") => `/surveys/edit/${surveyId}/pages`,

  USER_SURVEYS: "/user-surveys/",
  REGISTRATIONS: "/registrations/",
  REPORTS: "/reports/",
  REPORT: (reportId: string = ":reportId") => `/reports/${reportId}`,
  USER_SURVEY: (surveyId: string = ":surveyId") => `/user-surveys/${surveyId}`,

  DOCUMENT_TYPES: "/document-types/",
  DOCUMENT_TYPES_ADD: "/document-types/add/",
  DOCUMENT_TYPES_EDIT: (documentTypeId: string = ":documentTypeId") => `/document-types/edit/${documentTypeId}`,

  DASHBOARD: `/`,
  TASKS: `/tasks`,

  EMAILS: "/emails",

  EMAILS_TEMPLATE_PARAMETERS: `/parameters`,
  EMAILS_HISTORY: "/emails-history",
  EMAILS_TEMPLATES: "/templates",

  EMAILS_TRIGGERS: `/triggers`,
  EMAILS_TRIGGERS_ADD: `/triggers/add/`,
  EMAILS_TRIGGERS_EDIT: (emailTemplateId: string | number = ":emailTemplateId") => `/triggers/${emailTemplateId}`,

  SCHEDULED_EMAILS: "/scheduled-emails/",
  SCHEDULED_EMAILS_CREATE: "/scheduled-emails/create",
  SCHEDULED_EMAILS_EDIT: (id: string | number = ":id") => `/scheduled-emails/${id}/edit`,
  SCHEDULED_EMAILS_VIEW: (id: string | number = ":id") => `/scheduled-emails/${id}`,

  SCHEDULED_MESSAGES: "/scheduled-messages/",
  SCHEDULED_MESSAGES_CREATE: "/scheduled-messages/create",
  SCHEDULED_MESSAGES_EDIT: (id: string | number = ":id") => `/scheduled-messages/${id}/edit`,
  SCHEDULED_MESSAGES_VIEW: (id: string | number = ":id") => `/scheduled-messages/${id}`,

  DICTIONARIES: "/dictionaries/",
  DICTIONARIES_ADD: "/dictionaries/add/",
  DICTIONARIES_EDIT: (dictionaryId: string = ":dictionaryId") => `/dictionaries/edit/${dictionaryId}`,

  FINANCES: "/finances/",
  DELAYED_PAYMENTS: "/finances/delayed",
  COURSE_FINANCES_EDIT: (id: string = ":id") => `/finances/edit/${id}`,
  COURSE_FINANCES_CATEGORIES: "/finances/categories",
  COURSE_FINANCES_CATEGORIES_ADD: "/finances/categories/add",
  COURSE_FINANCES_CATEGORIES_EDIT: (id: string = ":id") => `/finances/categories/${id}`,

  COURSE_FINANCES: (groupId?: number, courseId?: number) => {
    const groupIdParam = groupId ? `groupId=${groupId}` : "";
    const courseIdParam = courseId ? `courseId=${courseId}` : "";
    const params = [groupIdParam, courseIdParam].filter((p) => p).join("&");
    return `/finances/list${params ? `?${params}` : ""}`;
  },

  DISCOUNTS: "/discounts/",
  DISCOUNTS_ADD: "/discounts/add/",
  DISCOUNTS_EDIT: (discountId: string = ":discountId") => `/discounts/edit/${discountId}`,
  DISCOUNTS_VIOLATED_BUNDLES: "/discounts/violated-bundles",

  TOPICS: "/topics/",
  TOPICS_ADD: "/topics/add",
  TOPICS_EDIT: (topicId: string = ":topicId") => `/topics/edit/${topicId}`,
  TOPICS_GROUPS: "/topicgroups/",
  TOPICS_GROUPS_ADD: "/topicgroups/add",
  TOPICS_GROUPS_EDIT: (topicGroupId: string = ":topicGroupId") => `/topicgroups/edit/${topicGroupId}`,

  PLACES: "/places/",
  PLACES_ADD: "/places/add/",
  PLACES_EDIT: (placeId: string = ":placeId") => `/places/edit/${placeId}`,
  SETTINGS: () => `/settings`,

  PLACE_TAGS: "/placetags/",
  PLACE_TAGS_ADD: "/placetags/add/",
  PLACE_TAGS_EDIT: (placeTagId: string = ":placeTagId") => `/placetags/edit/${placeTagId}`,

  TRAINER: (trainerId: string | number = ":trainerId") => `/trainers/${trainerId}`,
  TRAINERS: "/trainers/",
  TRAINERS_GROUPS: "/trainergroups",
  TRAINERS_GROUPS_ADD: "/trainergroups/add",
  TRAINERS_GROUPS_EDIT: (trainerGroupId: string = ":trainerGroupId") => `/trainergroups/edit/${trainerGroupId}`,
  TRAINERS_ADD: "/trainers/add/",
  TRAINERS_EDIT: (trainerId: string = ":trainerId") => `/trainers/edit/${trainerId}`,
  VERSIONS: "/versions",

  // Shop Landing Pages
  SHOP: "/shop",
  SHOP_LANDING_PAGES: "/shop/landing-pages",
  SHOP_LANDING_PAGES_ADD: "/shop/landing-pages/add",
  SHOP_LANDING_PAGES_EDIT: (landingPageId: string | number = ":landingPageId") =>
    `/shop/landing-pages/edit/${landingPageId}`,
  SHOP_BLOG: "/shop/blog",
  SHOP_BLOG_ADD: "/shop/blog/add",
  SHOP_BLOG_EDIT: (blogPostId: string | number = ":blogPostId") => `/shop/blog/${blogPostId}`,
  SHOP_REDIRECTS: "/shop/redirects",
  SHOP_CONTACT_FORM_SUBMISSIONS: "/shop/contact-form-submissions",
  SHOP_GOOGLE_ANALYTICS: "/shop/google-analytics",
  SHOP_META_PIXEL: "/shop/meta-pixel",

  // Static Files
  STATIC_FILES: "/static-files",

  TRAINER_LECTURE_CONFIRMATIONS: "/trainer-lecture-confirmations",

  // Dokumenty 2.0 (pdfme)
  DOCUMENTS_V2: "/documents-v2/",
  DOCUMENTS_V2_ADD: "/documents-v2/add/",
  DOCUMENTS_V2_EDITOR: (documentTemplateV2Id: string | number = ":documentTemplateV2Id") =>
    `/documents-v2/${documentTemplateV2Id}/editor`,
};
